import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import AboutMe from "./pages/AboutMe/AboutMe";
import Blogs from "./pages/Blogs/Blogs";
import Home from "./pages/HomeSection/Home/Home";
import Projects from "./pages/ProjectSection/Projects/Projects";
import NotFound from "./pages/SharedSection/NotFound/NotFound";

function App() {
    return (
        <div className="App text-light">
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    <Route exact path="/home">
                        <Home />
                    </Route>
                    <Route exact path="/aboutme">
                        <AboutMe />
                    </Route>
                    <Route exact path="/projects">
                        <Projects />
                    </Route>
                    <Route exact path="/blogs">
                        <Blogs />
                    </Route>
                    <Route path="*">
                        <NotFound />
                    </Route>
                </Switch>
            </Router>
        </div>
    );
}

export default App;
